/* eslint-disable react/jsx-wrap-multilines */
import * as React from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import 'typeface-inter';

import { AksaraProvider, GlobalStyles, NonIdealState, Paragraph, Anchor, Box } from '@aksara-ui/core';

import Logo from '../assets/images/logo-platform.png';
import MaintenanceImage from '../assets/images/maintenance.svg';

type StaticQueryProps = {
  site: {
    siteMetadata: {
      title: string;
      description: string;
      keywords: string;
      gitTag: string;
      gitRevision: string;
    };
  };
};

const MobileWrapper = styled('div')`
  position: relative;
  padding: 24px 40px;

  @media (min-width: 1024px) {
    display: none;
  }
`;

const MobileLogo = styled('img')`
  height: 32px;
`;

const NonMobileWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  @media (max-width: 1023px) {
    display: none;
  }
`;

export const IndexLayout: React.SFC = ({ children }) => (
  <StaticQuery
    query={graphql`
      query IndexLayoutQuery {
        site {
          siteMetadata {
            title
            description
            keywords
            gitTag
            gitRevision
          }
        }
      }
    `}
  >
    {(data: StaticQueryProps) => (
      <AksaraProvider>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: data.site.siteMetadata.description },
            { name: 'keywords', content: data.site.siteMetadata.keywords },
            { name: 'version', content: data.site.siteMetadata.gitTag },
            { name: 'revision', content: data.site.siteMetadata.gitRevision },
          ]}
        />
        <GlobalStyles />
        <MobileWrapper>
          <Box position="absolute" top="lg" left="lg">
            <MobileLogo src={Logo} className="maintenance-logo" alt="Kata Platform" />
          </Box>
          <NonIdealState
            variant="page"
            image={<img src={MaintenanceImage} className="maintenance-logo" alt="Kata Platform" />}
            title="Device Unsupported"
            content={
              <>
                <Paragraph color="grey07" mb="md">
                  To use Kata Platform, you need a desktop with a minimum screen width of 1024 pixels. We are sorry for
                  the inconvenience.
                </Paragraph>
                <Paragraph color="grey07">
                  Need help? Please reach out to{' '}
                  <Anchor href="mailto:support@kata.ai">
                    <strong>support[at]kata.ai</strong>
                  </Anchor>
                </Paragraph>
              </>
            }
          />
        </MobileWrapper>
        <NonMobileWrapper>{children}</NonMobileWrapper>
      </AksaraProvider>
    )}
  </StaticQuery>
);
